export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 100;
export const PASSWORD_SPECIAL_HINT = "! @ # . _ -";
export const ALLOWED_PASSWORD_SPECIALS_REGEX = /[!@#._-]/;
export const INVALID_PASSWORD_CHARS_REGEX = /[^A-Za-z0-9!@#._-]/;
export const PASSWORD_PLACEHOLDER = `${PASSWORD_MIN_LENGTH}+ karakter, ! @ # . _ -`;
export const PASSWORD_FOCUS_TEXT = `${PASSWORD_MIN_LENGTH}+ karakter, buyuk/kucuk harf, rakam ve ! @ # . _ - kullanin.`;

export function getPasswordValidationMessage(value = "") {
	const errors = [];

	if (value.length < PASSWORD_MIN_LENGTH) errors.push(`en az ${PASSWORD_MIN_LENGTH} karakter`);
	if (value.length > PASSWORD_MAX_LENGTH) errors.push(`en fazla ${PASSWORD_MAX_LENGTH} karakter`);
	if (!/[A-Z]/.test(value)) errors.push("buyuk harf");
	if (!/[a-z]/.test(value)) errors.push("kucuk harf");
	if (!/\d/.test(value)) errors.push("rakam");
	if (/\s/.test(value)) errors.push("bosluk olmamali");
	if (!ALLOWED_PASSWORD_SPECIALS_REGEX.test(value)) errors.push(`ozel karakter (${PASSWORD_SPECIAL_HINT})`);
	if (INVALID_PASSWORD_CHARS_REGEX.test(value)) errors.push(`yalnizca ${PASSWORD_SPECIAL_HINT}`);

	return errors.length ? `Eksik: ${errors.join(", ")}.` : "";
}
